import { useTranslation } from 'react-i18next';
import { CreatorApplicationsAdmin } from '../components/admin/CreatorApplicationsAdmin';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAppSelector } from '@/app/hooks';

const AdminCreatorApplicationsPage = () => {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.auth.user);
  const isAdmin = user?.role === 'ADMIN';

  if (!isAdmin) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-12">
        <Card>
          <CardHeader>
            <CardTitle>{t('admin.common.accessRequired', 'Admin access required')}</CardTitle>
            <CardDescription>{t('admin.common.noPermission', 'You do not have permission to view this page.')}</CardDescription>
          </CardHeader>
        </Card>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-10 space-y-8">
      <Card className="border-none shadow-none bg-transparent">
        <CardHeader className="px-0">
          <CardTitle className="text-3xl font-bold tracking-tight">
            {t('admin.creatorApplications.title', 'Creator Applications')}
          </CardTitle>
          <CardDescription className="text-base">
            {t('admin.creatorApplications.subtitle', 'Review applications, check portfolios, and manage creator discount levels.')}
          </CardDescription>
        </CardHeader>
      </Card>
      
      <CreatorApplicationsAdmin />
    </div>
  );
};

export default AdminCreatorApplicationsPage;
